import { orderIsFreeDutiesEligible } from "../../utils/orderIsFreeDutiesEligible";
import { RequestDutiesRefundCTA } from "./ctas";
import { TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE } from "./shared";
export var HowDutiesWorkIA = function HowDutiesWorkIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return ORDER_NOT_SELECTED(strictLocalize);
  }
  return orderIsFreeDutiesEligible(brandOrder) ? DUTIES_FREE_ORDER(strictLocalize) : NON_DUTIES_FREE_ORDER(strictLocalize);
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize, articles) {
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return undefined;
  }
  if (!orderIsFreeDutiesEligible(brandOrder)) {
    return undefined;
  }
  return RequestDutiesRefundCTA(strictLocalize, articles);
};
var ORDER_NOT_SELECTED = function ORDER_NOT_SELECTED(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var DUTIES_FREE_ORDER = function DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var NON_DUTIES_FREE_ORDER = function NON_DUTIES_FREE_ORDER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return HOW_DUTIES_WORK(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize), TAXES_AND_FEES_ARE_NOT_COVERED_BY_FAIRE(strictLocalize)];
    }
  };
};
var HOW_DUTIES_WORK = function HOW_DUTIES_WORK(strictLocalize) {
  return strictLocalize({
    id: "xfT++X",
    defaultMessage: [{
      "type": 0,
      "value": "Comment fonctionnent les droits de douane sur Faire ?"
    }]
  });
};
var DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS = function DUTIES_ARE_CALCULATED_ON_THE_TYPE_OF_GOODS(strictLocalize) {
  return strictLocalize({
    id: "X6z/E+",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane sont calculés en fonction du type de biens importés, tel que déterminé par les codes tarifaires fournis par la marque. Puisque les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si le coût réel des droits de douane et des frais de débours est supérieur à la remise appliquée pour les droits de douane, vous pourrez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "nyTq3Z",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane sont pris en charge sur cette commande. Les droits de douane sont calculés en fonction du type de biens importés, tel que déterminé par les codes tarifaires fournis par la marque. Si les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si le coût réel des droits de douane et des frais de débours est supérieur à la remise appliquée, vous pouvez demander le remboursement de la différence en crédit Faire une fois la commande livrée."
    }]
  });
};
var ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION = function ORDER_NOT_ELIGIBLE_FOR_DUTIES_FREE_PROMOTION(strictLocalize) {
  return strictLocalize({
    id: "S1hVGp",
    defaultMessage: [{
      "type": 0,
      "value": "Les droits de douane ne peuvent pas être pris en charge sur cette commande. Les droits de douane sont calculés en fonction du type de biens importés, tel que déterminé par les codes tarifaires fournis par la marque. Le transporteur vous enverra une facture incluant tous les frais (y compris les droits de douane et la TVA), que vous paierez en totalité. Si les droits de douane sont pris en charge pour votre commande, nous appliquerons lors du passage en caisse une remise correspondant au coût estimé des droits de douane pour votre commande."
    }]
  });
};